import * as React from 'react';
import { Button as BaseButton, Intent } from '@mc/react-core';
import classNames from 'classnames';

type Props = Omit<
  React.ComponentProps<typeof BaseButton>,
  'active' | 'outlined'
> & {
  fixedWidth?: boolean;
  className?: string;
};

export class Button extends React.PureComponent<Props> {
  render() {
    const { className, fixedWidth, intent, ...other } = this.props;

    const intentClass = (intent: Intent | undefined) => {
      if (intent == null || intent === Intent.NONE) {
        return `app-button-intent-none`;
      }
      return `app-button-intent-${intent.toLowerCase()}`;
    };

    return (
      <BaseButton
        className={classNames(className, intentClass(intent), {
          [`app-button-fw`]: fixedWidth,
        })}
        {...other}
      />
    );
  }
}
